<div class="container" [ngSwitch]="mode">
  <div class="scan" *ngSwitchCase="'scan'">
    <div class="input">
      <mat-form-field>
          <input type="text" #input1 autofocus [(ngModel)]="barValue" (change)="onChange()" name="discount"  matInput placeholder="">
      </mat-form-field>
    </div>
    <div *ngIf="loading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>
    <div class="text">
      Place your barcode on the scanner
    </div>
  </div>
  <div class="result" *ngSwitchCase="'result'">
    <table style="width:100%">
      <tr class="back">
          <th>
            <button class="create" mat-raised-button color="primary" [matMenuTriggerFor]="menu">
              More
            </button>

            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="markAll()">Colect All Samples</button>
              <button mat-menu-item [disabled]="disable" (click)="collectAll()">Collect Selected</button>
            </mat-menu>
          </th>
          <th>Acknowledged</th>
          <th>Service</th>
          <th>Name</th>
        <th>
          <button class="create" mat-raised-button color="primary" (click)="back()">
            Back
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let item of data" style="cursor: pointer;">
          <td><input type="checkbox" [checked]="item.selected" (change)="check(item, $event)"></td>
        <td *ngIf="item.sample_acknowledged == 'N'">{{item.sample_acknowledged}}</td>
        <td *ngIf="item.sample_acknowledged == 'Y'">
          <img style="width: 30px; height: 30px;" src="assets/icons/done.gif" alt="">
        </td>
        <td *ngIf="item.sample_acknowledged == 'N'">{{item.service_name}}</td>
        <td style="background-color: #BE5108; color: white;" *ngIf="item.sample_acknowledged == 'Y'">{{item.service_name}}</td>
        <td>{{item.patient_name}}</td>
        <td>
          <button style="width: 120px;" (click)="onSubmit(item)"  mat-raised-button color="primary"> Acknowledge</button>
        </td>
      </tr>
    </table>
  </div>

</div>
